
/**
 * AjaxManager Class
 * 
 * Central Ajax Manager
 * 
 * 
 * @class AjaxManager
 * @constructor
 * @requires moolite 1.0.3+
 * @type Class
 * 
 */

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.OCSAjaxManager = new Class({
    Implements: [Options],
    bound_methods: {},
    stored_request: {},
    options: {
        storeCompletedReq: 1000
    },
    initialize: function (op) {
        this.bound_methods.remove_request = this.remove_request.bind(this);
        this.setOptions(op);
    },
    request: function (request_name, ops, force) {
        if(!request_name) {
            return false;
        }
        if (this.stored_request.hasOwnProperty(request_name) && !force) {
            return this.stored_request[request_name];
        }
        if(!ops) {
            return false;
        }

        var request_obj;
        // Test for service worker
        ops.ajax_manager_request_name = request_name;
        if (typeof ops.storeCompletedReq === 'undefined') {
            ops.storeCompletedReq = this.options.storeCompletedReq;
        }
        if (OCS.is_worker && !Browser.Request && OCS.Functions.is_fetch_supported()) {
            request_obj = new OCS.Classes.AjaxFetchApiRequest(ops);
        } else {
            if (ops.dataType && ops.dataType === 'json') {
                request_obj = new OCS.Classes.AjaxXMLRequestJSON(ops);
            } else {
                request_obj = new OCS.Classes.AjaxXMLRequest(ops);
            }
        }
        this.stored_request[request_name] = request_obj;
        request_obj.addEvent('destroy', this.bound_methods.remove_request);
        return request_obj;
    },
    remove_request: function (request) {
        if (typeof request === 'string' && this.stored_request[request]) {
            delete this.stored_request[request];
        }
        if (typeof request !== 'string' && request.options && request.options.ajax_manager_request_name && this.stored_request[request.options.ajax_manager_request_name]) {
            delete this.stored_request[request.options.ajax_manager_request_name];
        }
    }
});
if (Browser.Request) {
    progressSupport = ('onprogress' in new Browser.Request());
} else {
    progressSupport = false;
}


